import logo from './logo.svg';
import './App.css';
import ScrollToTop from './pages/ScrollToTop';
import Navbar from './components/navbar/Navbar';
import { Route, Routes } from 'react-router-dom';
import { About, Contact, Home } from "./pages";
import Factories from './pages/Factories';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/single';
import Footer from './components/footer/Footer';
import Certification from './pages/Certification';
import Laptop from './pages/Laptop';
import Led from './pages/Led';
import Mobile from './pages/Mobile';
import Plastic from './pages/Plastic';
import SmartWatch from './pages/SmartWatch';
import Ac from './pages/Ac';
import Acer from './pages/Acer';
import Tws from './pages/Tws';
import OpenCell from './pages/OpenCell';
import Manufacturing from './pages/Manufacturing';
import SmtManufacturing from './pages/SmtManufacturing';
import Led_Manufacturing from './pages/Led_Manufacturing';

import Team from './pages/Team';
import History from './pages/History';
import Partners from './pages/Partners';
import Partner from './pages/Partner'
import Carrers from './pages/Carrers';
import Responsibility from './pages/Responsibility';
import Vision_Mission from './pages/Vision-Mission';
// import Csr from './pages/Csr'
// import EWaste from './pages/e-waste'
function App() {
  return (
    <div className="App">
      <ScrollToTop/>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/factories" element={<Factories />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs/>}/>
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/certification" element={<Certification />} />
        <Route path="/laptop" element={<Laptop />} />
        <Route path="/led" element={<Led />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/plastic" element={<Plastic />} />
        <Route path="/smartwatch" element={<SmartWatch />} />
        <Route path="/ac" element={<Ac />} />
        <Route path="/acer" element={<Acer />} />
        <Route path="/tws" element={<Tws />} />
        <Route path="/manufacturing" element={<Manufacturing/>} />
        <Route path="/tablet" element={<OpenCell/>} />
        <Route path="/smt-manufacturing" element={<SmtManufacturing/>} />
        <Route path="/led-manufacturing" element={<Led_Manufacturing/>} />
        <Route path="/mobile" element={<Mobile/>} />
        <Route path="/team" element={<Team/>} />
        <Route path="/history" element={<History/>} />
        <Route path="/vision-mission" element={<Vision_Mission/>} />
        <Route path="/careers" element={<Carrers/>} />
        <Route path="/responsibility" element={<Responsibility/>}/>
        {/* <Route path="/csr" element={<Csr/>} /> */}
        <Route path="*" element={<Home />} />
        <Route path="/partners" element={<Partners/>}/>
        <Route path="/partner" element={<Partner/>}/>
        {/* <Route path="/e-waste" element={<EWaste/>}/> */}
        
      </Routes>
     
      <Footer />
    </div>
  );
}

export default App;
